// More info on the statuses: https://www.douane.gouv.fr/sites/default/files/uploads/files/douane/EDI/Delta-G/Delta-C_guide_xml.pdf
export enum CustomsStatus {
  ACC = 'rectification_accepted',
  ANTICIPATED = 'anticipated',
  ANTICIPATED_BREXIT = 'anticipated_brexit',
  ARRIVED = 'arrived',
  BAE = 'bae',
  BAE_COMPLETE = 'bae_complete',
  BAE_DC = 'bae_dc',
  BAE_EBL = 'bae_ebl',
  BAE_EEC = 'bae_eec',
  BAE_ESD = 'bae_esd',
  BAE_ESO = 'bae_eso',
  BAE_EXPORTED = 'bae_exported',
  BAE_HEC = 'bae_hec',
  BAE_INVALIDATED = 'bae_invalidated',
  BAE_NOT_GRANTED = 'bae_not_granted',
  BAE_OUTSIDE_DC = 'bae_outside_dc',
  BAE_RECONCILIATION_DELAY_EXPIRED = 'bae_reconciliation_delay_expired',
  BAE_SOR = 'bae_sor',
  BAE_WAITING_DC = 'bae_waiting_dc',
  CANCELLED = 'cancelled',
  CASH_PAYMENT = 'cash_payment',
  CEA = 'cea',
  CLOSED = 'closed',
  COMPLETED = 'completed',
  DAN = 'cancelled_rectification',
  DISCHARGE_DELAY_EXCEEDED = 'discharge_delay_exceeded',
  DISCHARGED = 'discharged',
  DISCHARGED_WITH_DIFFERENCE = 'discharged_with_difference',
  DIVERSION_DELAY_EXCEEDED = 'diversion_delay_exceeded',
  DIVERTED = 'diverted',
  DRAFT = 'draft',
  EARLY_NOTICE_ARRIVAL_REQUESTED = 'early_notice_arrival_requested',
  EMITTED_INCOMPLETE = 'emitted_incomplete',
  EMITTED = 'emitted',
  ENGAGED_RESEARCH = 'engaged_research',
  EXPORT_DECLARATION_ACCEPTED = 'export_declaration_accepted',
  EXPORT_DECLARATION_REFUSED = 'export_declaration_refused',
  EXPORT_IN_PROGRESS = 'export_in_progress',
  EXPORT_INVALIDATED = 'export_invalidated',
  GUARANTEE_INQUIRY = 'guarantee_inquiry',
  INFORMATION_REQUEST = 'information_request',
  INVALIDATED = 'invalidated',
  INVALIDATION_REQUESTED = 'invalidation_requested',
  INVALID_GUARANTEE = 'invalid_guarantee',
  INV_EAN = 'invalidated_bae',
  MND = 'mnd',
  NOTIF_ARRIVAL_DESTINATION = 'notif_arrival_destination',
  NOTIF_BOARDING = 'notif_boarding',
  NOTIF_DIFFERENCES = 'notif_differences',
  NOTIF_INCIDENT = 'notif_incident',
  NOTIF_NEED_RECTIFICATION = 'notif_need_rectification',
  PARTIALLY_REFUSED = 'partially_refused',
  RECOVERY_INFORMATION = 'recovery_information',
  RECTIFICATION_PENDING = 'rectification_pending',
  RECTIFICATION_REQUESTED = 'rectification_requested',
  REF = 'ref',
  REFUSED = 'refused',
  REJECTED = 'rejected',
  REGULARIZED = 'regularized',
  REGISTERED_GUARANTEE = 'registered_guarantee',
  REGISTERED_REQUEST = 'registered_request',
  RELEASED = 'released',
  REPORTED = 'reported',
  REQUEST_EXTENSION = 'request_extension',
  SPLITTED = 'splitted',
  STOPPED = 'stopped',
  UNLOADING_AUTHORIZED = 'unloading_authorized',
  UNDER_CONTROL = 'under_control',
  VALIDATED = 'validated',
  WAITING_VALIDATION = 'waiting_validation',
  WARRANTY_ISSUE = 'warranty_issue'
}

export enum WarningCustomsStatus {
  BAE_RECONCILIATION_DELAY_EXPIRED = 'bae_reconciliation_delay_expired',
  BAE_OUTSIDE_DC = 'bae_outside_dc',
  BAE_WAITING_DC = 'bae_waiting_dc',
  NOTIF_INCIDENT = 'notif_incident',
  DISCHARGE_DELAY_EXCEEDED = 'discharge_delay_exceeded',
  DIVERSION_DELAY_EXCEEDED = 'diversion_delay_exceeded',
  STOPPED = 'stopped',
  PARTIALLY_REFUSED = 'partially_refused',
  EXPORT_INVALIDATED = 'export_invalidated',
  DISCHARGED_WITH_DIFFERENCE = 'discharged_with_difference'
}

export enum NegativeCustomsStatus {
  NOTIF_NEED_RECTIFICATION = 'notif_need_rectification',
  REFUSED = 'refused',
  REJECTED = 'rejected',
  EXPORT_DECLARATION_REFUSED = 'export_declaration_refused',
  BAE_NOT_GRANTED = 'bae_not_granted'
}

export enum CustomsStatusDeltaT {
  ARRIVED = 'arrived',
  ANTICIPATED = 'anticipated',
  AVIS_ANT_ARRIV_DEM = 'avis_ant_arrival_demand',
  BAE = 'bae',
  DISCHARGED = 'discharged',
  ENGAGED_RESEARCH = 'engaged_research',
  INFORMATION_REQUEST = 'information_request',
  INVALID_GUARANTEE = 'invalid_guarantee',
  INVALIDATED = 'invalidated',
  INVALIDATION_REQUESTED = 'invalidation_requested',
  NOTIF_ARRIVAL_DESTINATION = 'notif_arrival_destination',
  NOTIF_BOARDING = 'notif_boarding',
  REGISTERED_GUARANTEE = 'registered_guarantee',
  RELEASED = 'released',
  UNDER_CONTROL = 'under_control',
  UNLOADING_AUTHORIZED = 'unloading_authorized',
  VALIDATED = 'validated'
}

export enum CustomsStatusDeltaI {
  ANTICIPATED = 'anticipated',
  ANTICIPATED_BREXIT = 'anticipated_brexit',
  BAE = 'bae',
  BAE_WAITING_DC = 'bae_waiting_dc',
  BAE_DC = 'bae_dc',
  CANCELLED = 'cancelled',
  INVALIDATED = 'invalidated',
  VALIDATED = 'validated'
}

export enum CustomsStatusDeltaE {
  ANTICIPATED = 'anticipated',
  ANTICIPATED_BREXIT = 'anticipated_brexit',
  BAE = 'bae',
  BAE_WAITING_DC = 'bae_waiting_dc',
  BAE_DC = 'bae_dc',
  BAE_EXPORTED = 'bae_exported',
  CANCELLED = 'cancelled',
  INVALIDATED = 'invalidated',
  VALIDATED = 'validated',
  INFORMATION_REQUEST = 'information_request'
}

export enum CustomsStatusGamma {
  EMITTED_INCOMPLETE = 'emitted_incomplete',
  EMITTED = 'emitted'
}

export enum DeclarationStates {
  IN_PROCESS = 'in_process',
  IN_ERROR = 'in_error',
  IN_PROGRESS = 'in_progress',
  TEMPLATE = 'template',
  SCHEDULED = 'scheduled'
}

export const SCHEDULE_CANCEL_MIN_LEAD_MINUTES = 3;

export enum ProcessingTimeStatus {
  NORMAL = 'normal',
  SLOW = 'slow',
  BLOCKED = 'blocked'
}

export const PROCESSING_TIME_NORMAL_MAX_SECONDS = 60;
export const PROCESSING_TIME_SLOW_MAX_SECONDS = 600;
export const PROCESSING_TIME_SLOT_MINUTES = 15;

export enum OperationTypes {
  CREDIT = 'credit',
  DEBIT = 'debit'
}

export interface Lifecycle {
  customs_status: CustomsStatus | null;
  declaration_state: DeclarationStates;
  modification_date: string;
  modified_by: string;
  ccs_state?: CCSState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customs_flow?: any;
  restored_at?: string | null;
}

export enum CCSState {
  IN_CONTROL = 'IN_CONTROL',
  IN_INJECTION = 'IN_INJECTION',
  IN_TRACING = 'IN_TRACING',
  TRACING_OK = 'TRACING_OK',
  NOTIFICATION = 'NOTIFICATION',
  CONTROL_OK = 'CONTROL_OK',
  CONTROL_KO = 'CONTROL_KO',
  IN_INJECTION_CIN = 'IN_INJECTION_CIN',
  INJECTION_OK_CIN = 'INJECTION_OK_CIN',
  INJECTION_KO_CIN = 'INJECTION_KO_CIN'
}

export enum TiersTypes {
  REPRESENTANT = 'representant',
  FISCAL_REPRESENTANT = 'fiscal_representant',
  RECIPIENT = 'recipient',
  FINAL_RECIPIENT = 'final_recipient',
  BENEFICIARY = 'beneficiary',
  EXPEDITOR = 'expeditor',
  APPLICANT = 'applicant',
  ALL = 'all'
}

export enum Actions {
  OVERRIDE = 'override',
  ADD = 'add',
  UPDATE = 'update',
  ADD_CONTAINERS = 'add-containers'
}

export enum DeclarationTypes {
  DELTA_G = 'delta_g',
  DELTA_IE = 'delta_ie',
  DELTA_G_IMPORT = 'delta_g_import',
  DELTA_G_EXPORT = 'delta_g_export',
  DELTA_I = 'delta_i',
  DELTA_E = 'delta_e',
  DELTA_T = 'delta_t',
  DELTA_T_DECLARATION = 'delta_t_declaration',
  DELTA_T_NOTIFICATION = 'delta_t_notification',
  DELTA_T_REPORT = 'delta_t_report',
  GAMMA = 'gamma',
  GAMMA_DAE = 'gamma_dae',
  GAMMA_DAE_CONSIGNEE = 'gamma_dae_consignee',
  GAMMA_DAE_CONSIGNOR = 'gamma_dae_consignor',
  GAMMA_DAES = 'gamma_daes',
  GAMMA_DAES_CONSIGNEE = 'gamma_daes_consignee',
  GAMMA_DAES_CONSIGNOR = 'gamma_daes_consignor',
  GAMMA_DSA = 'gamma_dsa',
  GAMMA_MVV = 'gamma_mvv',
  AUDIT = 'audit'
}

export const DeclarationTypesGamma: readonly DeclarationTypes[] = [
  DeclarationTypes.GAMMA_DAE_CONSIGNEE,
  DeclarationTypes.GAMMA_DAE_CONSIGNOR,
  DeclarationTypes.GAMMA_DAES_CONSIGNEE,
  DeclarationTypes.GAMMA_DAES_CONSIGNOR,
  DeclarationTypes.GAMMA_DSA,
  DeclarationTypes.GAMMA_MVV
];

export enum OCRMode {
  DAE_DGDDI = 'dae_dgddi',
  DAE_CIVB = 'dae_civb'
}

export const OCRApplyMode = {
  MERGE: 'merge',
  OVERWRITE: 'overwrite'
} as const;

export type OCRApplyMode = (typeof OCRApplyMode)[keyof typeof OCRApplyMode];

export enum DeclarationPartiesTypes {
  CONSIGNEES = 'consignees',
  CONSIGNORS = 'consignors',
  EXPORTERS = 'exporters',
  IMPORTERS = 'importers',
  CARRIERS = 'carriers',
  DECLARANTS = 'declarants',
  REPRESENTATIVES = 'representatives',
  SELLERS = 'sellers',
  BUYERS = 'buyers',
  HOLDERS_OF_THE_TRANSIT_PROCEDURE = 'holdersOfTheTransitProcedure'
}

export const DECLARATION_PARTY_FILTER_LABEL_KEYS: Record<DeclarationPartiesTypes, string> = {
  [DeclarationPartiesTypes.CONSIGNEES]: 'declarations_page.consignee',
  [DeclarationPartiesTypes.CONSIGNORS]: 'declarations_page.consignor',
  [DeclarationPartiesTypes.EXPORTERS]: 'declarations_page.exporter',
  [DeclarationPartiesTypes.IMPORTERS]: 'declarations_page.importer',
  [DeclarationPartiesTypes.CARRIERS]: 'declarations_page.carrier',
  [DeclarationPartiesTypes.DECLARANTS]: 'declarations_page.declarant',
  [DeclarationPartiesTypes.REPRESENTATIVES]: 'declarations_page.representant',
  [DeclarationPartiesTypes.SELLERS]: 'seller',
  [DeclarationPartiesTypes.BUYERS]: 'buyer',
  [DeclarationPartiesTypes.HOLDERS_OF_THE_TRANSIT_PROCEDURE]: 'declarations_page.holder_of_the_transit_procedure'
};

export const FILTER_EXCLUDED_STATUSES = [
  'template',
  'draft',
  'warranty_issue',
  'bae_sor',
  'edited',
  'bae_invalidated',
  'rectification_accepted',
  'cancelled_rectification'
] as const;

// Statistics model properties (camelCase) holding a filter value, shown in a model description.
// Mirrors the persisted filter fields of the back-end StatisticsModelRead schema.

// Statistics model properties (camelCase) holding a filter value, shown in a model description.
// Mirrors the persisted filter fields of the back-end StatisticsModelRead schema.
export const STATISTICS_MODEL_DESCRIPTION_FIELDS = [
  'status',
  'currency',
  'declarationType',
  'tags',
  'regulations',
  'declarant',
  'consignorName',
  'consignorIdentifier',
  'consigneeName',
  'consigneeIdentifier',
  'importerName',
  'importerIdentifier',
  'exporterName',
  'exporterIdentifier',
  'sellerName',
  'sellerIdentifier',
  'buyerName',
  'buyerIdentifier',
  'carrierName',
  'carrierIdentifier',
  'representativeName',
  'representativeIdentifier',
  'declarantsName',
  'declarantsIdentifier',
  'holderOfTheTransitProcedureName',
  'holderOfTheTransitProcedureIdentifier',
  'officePresentation',
  'containerNumber',
  'commercialDesc',
  'nomencCode',
  'docRef',
  'logisticReference',
  'declOwner',
  'lastModifName',
  'd48',
  'docType',
  'destCountry',
  'origin',
  'requestedRegime',
  'previousRegime'
] as const;

export const MODERN_DECLARATION_TYPES = [
  DeclarationTypes.DELTA_IE,
  DeclarationTypes.DELTA_I,
  DeclarationTypes.DELTA_E,
  DeclarationTypes.DELTA_T,
  DeclarationTypes.DELTA_T_DECLARATION,
  DeclarationTypes.DELTA_T_NOTIFICATION,
  DeclarationTypes.DELTA_T_REPORT
] as const;

export type ModernDeclarationType = (typeof MODERN_DECLARATION_TYPES)[number];

export enum CustomsDocumentTypes {
  TAD = 'TAD',
  DEC = 'DEC',
  DAU = 'DAU',
  AI2 = 'AI2',
  ATR = 'ATR',
  EUR1 = 'EUR1',
  DOCK_DUES_CERTIFICATE = 'DOCK_DUES_CERTIFICATE'
}

export enum CustomsDocumentSubTypes {
  DRAFT = 'DRAFT',
  TEMPORARY = 'TEMPORARY',
  FALLBACK = 'FALLBACK',
  AI2 = 'AI2'
}

export enum sidePannel {
  MENU = 'menu',
  TIMELINE = 'timeline',
  DOCUMENT = 'document'
}

export enum ResponseTypesDeltaI {
  IE404 = 'IE404', // ANTICIPATION MODIFIED
  IE410 = 'IE410', // CANCELLED
  IE426 = 'IE426', // ANTICIPATED
  IE428 = 'IE428', // ACCEPTED
  IE429 = 'IE429', // BAE
  IE431 = 'IE431', // Notification of DC deposit nearing expiration
  IE451 = 'IE451', // MND
  IE456 = 'IE456', // Functional error
  IE460 = 'IE460', // Controls message
  IE917 = 'IE917', // Technical error
  FRA101 = 'FRA101',
  FRA102 = 'FRA102', // REGISTERED REQUEST
  FRA103 = 'FRA103' // REQUEST INSTRUCTION EXTENSION
}

export enum ResponseTypesDeltaE {
  IE504 = 'IE504', // ANTICIPATION MODIFIED
  IE509 = 'IE509', // INVALIDATED
  IE514 = 'IE514', // Cancellation / Invalidation
  IE528 = 'IE528', // ACCEPTED
  IE529 = 'IE529', // BAE
  IE531 = 'IE531', // Notification of DC deposit nearing expiration
  IE551 = 'IE551', // MND
  IE556 = 'IE556', // Functional error
  IE560 = 'IE560', // Controls message
  IE582 = 'IE582', // Request for information on non-exited exportation
  IE599 = 'IE599', // Export notification
  IE917 = 'IE917', // Technical error
  FRA101 = 'FRA101',
  FRA102 = 'FRA102', // REGISTERED REQUEST
  FRA103 = 'FRA103', // REQUEST INSTRUCTION EXTENSION
  FRA104 = 'FRA104' // ANTICIPATED
}

export enum SendTypesLabel {
  VALIDATION = 'validation',
  VALIDATION_AUTO = 'validation_auto',
  ANTICIPATION = 'anticipation',
  CANCELLATION = 'cancellation',
  REQUESTING_CORRECTION = 'requesting_correction',
  INVALIDATION = 'invalidation',
  CONTROL = 'CONTROL',
  SEND_INFORMATION = 'send_information',
  NOTIFICATION = 'notification',
  UNLOADING_REPORT = 'unloading_report'
}

/** IE413/IE513 amendment motivation when modifying an anticipated declaration. */
// change in back-end project if this changes here

/** IE413/IE513 amendment motivation when modifying an anticipated declaration. */
// change in back-end project if this changes here
export const ANTICIPATION_AMENDMENT_MOTIVATION = 'MODIF';

/** IE413/IE513 amendment reason when modifying an anticipated declaration. */

/** IE413/IE513 amendment reason when modifying an anticipated declaration. */
export const ANTICIPATION_AMENDMENT_REASON = 'Modification de la déclaration anticipée';

export enum SendTypesDeltaI {
  IE413 = 'IE413', // Rectification or modification of an anticipation
  IE414 = 'IE414', // Cancellation, invalidation
  IE415 = 'IE415', // Creation of a new declaration
  IE432 = 'IE432' // Creation of a presentation notification
}

export enum SendTypesDeltaE {
  IE511 = 'IE511', // Creation of a presentation notification
  IE513 = 'IE513', // Rectification
  IE514 = 'IE514', // Cancellation, invalidation
  IE515 = 'IE515', // Creation of a new declaration
  IE583 = 'IE583' // Response to information request (IE582)
}

export const INCOTERMS_REQUIRING_ADD_FEES = ['EXW', 'FCA', 'FAS'];

export const INCOTERMS_REQUIRING_DEDUCT_FEES = ['CPT', 'CFR', 'CIP', 'CIF', 'DAP', 'DPU', 'DDP'];

export enum ResponseTypesDeltaT {
  CC028C = 'CC028C', // ACCEPTED
  CC029C = 'CC029C', // BAE
  CCF02C = 'CCF02C', // ANTICIPATED
  CC917C = 'CC917C', // Technical error
  CC056C = 'CC056C', // Functional error
  CC057C = 'CC057C', // Functional error
  CC004C = 'CC004C', // Acceptance of rectification request
  CC009C = 'CC009C', // Acceptance of invalidation request
  CC019C = 'CC019C', // Notification of differences at destination to the operator of departure
  CC022C = 'CC022C', // Notification of the need to rectify the declaration refused by the exit office for export
  CC035C = 'CC035C', // Declaration registration - MRN assignment
  CC037C = 'CC037C', // Response to guarantee inquiry
  CC045C = 'CC045C', // Movement discharge
  CC055C = 'CC055C', // Notification of invalid guarantee
  CC058D = 'CC058D', // Functional rejection after CC117D
  CC140C = 'CC140C', // Information request to the holder of the Transit regime
  CC182C = 'CC182C', // Notification of incident during transit
  CC025C = 'CC025C', // Release of goods at destination
  CC043C = 'CC043C', // Authorization for unloading in authorized consignee procedure
  CCF03C = 'CCF03C' // Acceptance of arrival notification
}

export enum ResponseTypesGamma {
  FRA801 = 'FRA801', // Report of receipt
  FRA906 = 'FRA906', // Functional error
  FRA917 = 'FRA917' // Technical error
}

export enum SendTypesDeltaTDeclaration {
  CC015C = 'CC015C', // Creation of a new declaration
  CC013C = 'CC013C', // Rectification
  CC014C = 'CC014C', // Cancellation, invalidation
  CC034C = 'CC034C', // Interrogation of a guarantee
  CC117D = 'CC117D', // Notification of arrival at the transit office
  CC170C = 'CC170C', // Creation of a presentation notification
  CC141C = 'CC141C' // Send information requested by customs
}

export enum SendTypesDeltaTNotification {
  CC007C = 'CC007C' // Creation of a new declaration
}

export enum SendTypesDeltaTReport {
  CC044C = 'CC044C' // Creation of a new declaration
}

export enum SendTypesCCS {
  AES755F = 'MessageAES755F' // Force send to CIN
}

export enum EDIProtocolTypes {
  EMAIL = 'EmailProtocole',
  FTP = 'FTPProtocole',
  SFTP = 'SFTPProtocole',
  HTTP = 'HTTPProtocole'
}

/**
  - FR002300 : Marseille/Fos
  - FR001260 : Dunkerque
  - FR000610 : Bordeaux
  - FR006340 : Fort de France
  - FR006370 : Guyane
  - FR006420 : Mayotte
  - FR004250 : Sète
  - FR006390 : Nouméa
**/

export const PCSDesk = {
  CI5: ['FR002300', 'FR001260', 'FR000610', 'FR006340', 'FR006370', 'FR006420', 'FR004250', 'FR006390']
};

// TODO : Remove this enum and spread it to SendTypesCCS
export enum CCSActions {
  CONTROL = 'CONTROL',
  INJECTION = 'INJECTION',
  TRACING = 'TRACING'
}

export enum ICS2Actions {
  ICS2 = 'ICS2',
  IE3F15 = 'IE3F15',
  IE3F50 = 'IE3F50',
  IE3F51 = 'IE3F51'
}

export enum OCRState {
  PENDING = 'PENDING',
  EXTRACTION_SUCCESS = 'EXTRACTION_SUCCESS',
  EXTRACTION_FAIL = 'EXTRACTION_FAIL'
}

export enum OCRDocumentType {
  INVOICE = 'invoice',
  BILL_OF_LADING = 'bill_of_lading',
  PACKING_LIST = 'packing_list'
}

export enum OCRObjectType {
  DECLARATION = 'declaration',
  CUSTOMS_BASE = 'customs_base',
  SEARCH_FOLDER = 'search_folder'
}

export enum TemplateTypes {
  BUSINESS_PARTNER = 'business_partner',
  ARTICLE = 'article',
  CONTACT_PERSON = 'contact_person',
  REPRESENTATIVE = 'representative'
}

export const ADDITIONS_AND_DEDUCTIONS_FEE_TYPES = [
  { value: 'preCustomsFees', airOnly: true },
  { value: 'thirdPartyFees', freightCostDerived: true },
  { value: 'excludedAmountCE', freightCostDerived: true },
  { value: 'excludedAmountFR', freightCostDerived: true },
  { value: 'insuranceFees' },
  { value: 'postCustomsFees', airOnly: true },
  { value: 'otherFeesToAddToVATValue' }
] as const;

/**
 * Actions carried by the unique MVVDSA message (Entete.TypeAction).
 * The action to perform is discriminated by this field, not by the message type.
 */
export const MvvDsaTypeAction = {
  CREATION: 'CREATION',
  CREATION_ENLEVEMENT_PROPRIETE: 'CREATION_ENLEVEMENT_PROPRIETE',
  COMPLETION_ENLEVEMENT_PROPRIETE: 'COMPLETION_ENLEVEMENT_PROPRIETE',
  ANNULATION: 'ANNULATION'
} as const;
